module.exports = __webpack_public_path__ + "media/customize/logo-upload-placeholder-f43f60db.svg";